/**
 * 레이아웃 계산 관련 유틸리티 함수들
 */ import { LAYOUT_BREAKPOINTS, getSidebarWidth } from '@edusense/shared-constants';
// Backward compatibility alias
const BREAKPOINTS = {
    sm: LAYOUT_BREAKPOINTS.SM,
    md: LAYOUT_BREAKPOINTS.MD,
    lg: LAYOUT_BREAKPOINTS.LG,
    xl: LAYOUT_BREAKPOINTS.XL
};
/**
 * 그리드 템플릿 컬럼을 계산하는 함수
 */ export const calculateGridTemplateColumns = (isMobileView, hideNavigation, isLecturePage, isSidebarVisibleOnLecture, isRoadmapCreatePage, isSidebarVisibleOnRoadmapCreate, showRightSidebar, isChatSidebarMode, windowWidth, chatSidebarWidth)=>{
    if (isMobileView) return undefined;
    const leftSidebar = hideNavigation || isLecturePage && !isSidebarVisibleOnLecture || isRoadmapCreatePage && !isSidebarVisibleOnRoadmapCreate ? '0px' : `${getSidebarWidth(windowWidth)}px`; // shared constants로 통일된 사이드바 너비
    const rightSidebar = showRightSidebar || isChatSidebarMode ? `${chatSidebarWidth}px` : '0px';
    return `${leftSidebar} 1fr ${rightSidebar}`;
};
/**
 * 사이드바를 숨겨야 하는지 판단하는 함수
 */ export const shouldHideSidebar = (isMobileView, hideNavigation, isLecturePage, isSidebarVisibleOnLecture, isRoadmapCreatePage, isSidebarVisibleOnRoadmapCreate)=>{
    return isMobileView || hideNavigation || isLecturePage && !isSidebarVisibleOnLecture || isRoadmapCreatePage && !isSidebarVisibleOnRoadmapCreate;
};
/**
 * 채팅 사이드바의 이상적인 너비를 계산하는 함수
 */ export const calculateIdealChatWidth = (windowWidth, isResizing, clientX)=>{
    if (isResizing && clientX !== undefined) {
        const newWidth = windowWidth - clientX;
        const minWidth = 400;
        const maxWidth = Math.min(1000, windowWidth * 0.6); // 최대 너비를 60%로 제한
        return Math.max(minWidth, Math.min(maxWidth, newWidth));
    }
    // 기본값 반환
    return 600;
};
/**
 * 디바이스 타입을 감지하는 함수
 */ export const getDeviceType = (windowWidth)=>{
    if (windowWidth < BREAKPOINTS.md) return 'mobile';
    if (windowWidth < BREAKPOINTS.lg) return 'tablet';
    return 'desktop';
};
/**
 * 채팅 사이드바 리사이즈 제약 조건을 계산하는 함수
 */ export const calculateResizeConstraints = (windowWidth)=>{
    const minWidth = 400;
    const maxWidth = Math.min(1000, windowWidth * 0.6);
    return {
        minWidth,
        maxWidth,
        isValidWidth: (width)=>width >= minWidth && width <= maxWidth
    };
};
/**
 * 사이드바 컨테이너의 left 위치를 계산하는 함수
 */ export const calculateSidebarLeftPosition = (sidebarContainerElement)=>{
    if (!sidebarContainerElement) return 0;
    const rect = sidebarContainerElement.getBoundingClientRect();
    return rect.left;
};
/**
 * 레이아웃 상태에 따른 CSS 클래스를 생성하는 함수
 */ export const generateLayoutClasses = (isVSCodeEnv, isLecturePage, isSidebarVisibleOnLecture, isRoadmapCreatePage, isSidebarVisibleOnRoadmapCreate, className)=>{
    const classes = [];
    if (className) classes.push(className);
    if (isVSCodeEnv) classes.push('vscode-layout');
    if (isLecturePage && !isSidebarVisibleOnLecture) classes.push('lecture-mode');
    if (isRoadmapCreatePage && !isSidebarVisibleOnRoadmapCreate) classes.push('fullscreen-mode');
    return classes.join(' ');
};
